import { combineReducers } from 'redux';

import productList from './product-list-reducer';
import productPrices from './price-reducer';
import modelPrices from './components/product-price/model-reducer';
import sortReducer from './sort-reducer';

const preSortData = combineReducers({
    productList,
    productPrices,
    modelPrices
});

const NULL_STATE = {
    productList: {},
    productPrices: {},
    modelPrices: {}
}

const ProductInfoReducer = (state = NULL_STATE, action) => {
    const intermediateState = preSortData(state,action);
    const finalState = sortReducer(intermediateState, action);
    return finalState;
}

export default ProductInfoReducer;
